module.exports = __webpack_public_path__ + "static/img/zx-wx.d99d0b45.jpg";